<template>
  <div class="home-wrap">
    <swiper/>
    <!--4大优势-->
    <div class="advantage">
      <img class="bg" src="../../assets/images/home/bg4.png" alt="">
      <div class="advantage_box">
        <div class="box1 wow animated fadeInLeft">
          <p class="city">台州市</p>
          <p class="company">中鹏（浙江）机械有限公司</p>
        </div>
        <div class="box2 wow animated fadeInRight">
          <div class="box-item" v-for="item in advantageList" :key="item.id">
            <div class="num">{{ item.id }}</div>
            <div class="content">
              <div class="title">{{ item.title }}</div>
              <div class="txt">{{ item.text }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 文化宗旨 -->
    <div class="abcont5">
      <h2Title title1='Cultural' title2='文化宗旨'></h2Title>
      <div class="abcont5-con">
        <div class="abcont5-con1">
          <div class="psty3">&mdash;&mdash;&mdash;&emsp;&emsp;技术创新是企业发展的动力，质量是企业的生命，服务是“心虔志诚，客户至上</div>
          <div class="english">Technological innovation is the driving force for enterprise development, quality is the life of the enterprise, and service is "devout and sincere, customer first"</div>
        </div>
        <img class="image" src="../../assets/images/home/abimg8.png">
      </div>
      <div class="abcont5-con">
        <img class="image" src="../../assets/images/home/abimg7.png">
        <div class="abcont5-con2">
          <div class="psty3">企业精神 - 金牌技术，优质服务&emsp;&emsp;&mdash;&mdash;&mdash;</div>
          <div class="english">Corporate Spirit - Gold Medal Technology, High Quality Service</div>
        </div>
      </div>
    </div>
    <!-- 业务范围 -->
    <div class="abcont2 con">
      <h2Title title1='Advanced Equipment, First Class Capacity' title2='先进设备， 一流实力'></h2Title>
      <div class="abp-sty2">中鹏（浙江）机械有限公司拥有强大的机械设备制造能力，引进国内一流的矿山机械加工设备。我们坚持不断地创新，持续改进产品，不 断提高产品的可靠性，我们立志成为破碎筛分行业的世界品牌。</div>
      <div class="abp-sty2" style="margin-top: 8px;color: #999999">Minwei owns a strong manufacturing capacity in mechanical equipment and has introduced the domestic first class mining machinery
        processing equipments. We adhere to constant innovation and continuous improvement to promote the product reliability. We are determined to become
        a world brand in crushing and screening industry.
      </div>
      <div class="abcont2-1">
        <div class="abcont2l abcimg1">
          <img src="../../assets/images/home/c1.png">
        </div>
        <div class="abcont2c">
          <div class="abcimg2">
            <img src="../../assets/images/home/c2.png">
          </div>
          <div class="abcimg3">
            <img src="../../assets/images/home/c3.png">
          </div>
          <div class="abcimg4">
            <img src="../../assets/images/home/c4.png">
          </div>
          <div class="abcimg5">
            <img src="../../assets/images/home/c5.png">
          </div>
        </div>
        <div class="abcont2r abcimg6">
          <img src="../../assets/images/home/c6.png">
        </div>
      </div>
      <div @click="goMore" style="width: 300px;margin-top: 30px;cursor: pointer">
        <el-divider>查看更多</el-divider>
      </div>
    </div>

  </div>
</template>

<script>
import Swiper from "@/views/home/Swiper";
import h2Title from './h2Title'
export default {
  name: "Home",
  components: { Swiper, h2Title },
  data () {
    return {
      tabPosition: 'left',
      advantageList: [
        {
          id: '1',
          title: '质量保证',
          text: '中鹏矿山机械设备符合各种要求，安全合规，质量经得起考验，性价比高。'
        },
        {
          id: '2',
          title: '价格保证',
          text: '我们拥有自己的生产线厂家直供、没有中间价、价格更优惠。'
        },
        {
          id: '3',
          title: '五星服务支持',
          text: '售前、售中、售后三个阶段对客户实行一对一服务，360°为客户提供服务。'
        },
        {
          id: '4',
          title: '强大的物流运输服务',
          text: '专业的物流运输服务公司，线路齐全，运输速度快，确保客户的设备可以更快更安全的到达客户手中，免去了运输不方便的烦恼。'
        }
      ]
    }
  },
  methods: {
    goMore () {
      this.$router.push({
        path:'/project'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .advantage{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .bg{
      width: 70%;
    }
    .advantage_box{
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      width:100%;
      height:360px;
      margin: 60px 20px 20px 20px;
      .box1{
        width: 265px;
        height:360px;
        margin-right: 40px;
        float: left;
        background-image: url('../../assets/images/home/bg5.png');
        background-repeat: no-repeat;
        text-align: left;
        font-size: 16px;
        .city{
          margin:50px 0px 0px 20px;
        }
        .company{
          margin:10px 0px 0px 20px;
          font-weight: 700;
        }
      }
      .box2{
        width:780px;
        float: left;
        .box-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          height: 80px;
          .num {
            width:80px;
            height:70px;
            line-height: 70px;
            text-align: center;
            font-size: 36px;
            color:#fff;
          }
          .content {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex: 1;
            background: #FFFFFF;
            padding-left: 16px;
            height: 80px;
            .title {
              font-size: 24px;
              font-weight: 700;
            }
            .txt {
              font-size:16px;
              font-weight: 700;
              letter-spacing:3px;
            }
          }
          &:nth-child(2n-1) {
            background: #228bf9;
          }
          &:nth-child(2n) {
            background: #88daf2;
          }
        }
      }
    }
  }
  .abcont5{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('../../assets/images/home/abimg6.jpg') no-repeat center;
    color: #FFF;
    padding: 30px 10%;
    font-size: 16px;
    .h1Title{
      margin-bottom: 35px;
    }
    .abcont5-con{
      width: 100%;
      display: flex;
      flex-flow: row;
      //.image {
      //  width: 50%;
      //  height: 100%;
      //}
    }
    .abcont5-con1{
      display: flex;
      width: 50%;
      flex-direction: column;
      justify-content: space-around;
      margin-right: 40px;
    }
    //.psty3{padding-bottom: 15px;}
    .abcont5-con2{
      padding-top: 30px;
      margin-left: 40px;
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

  }

  .abcont2{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 50px;
    width: 100%;
    height: 100%;
    overflow: auto;
    .abp-sty2{
      font-size: 16px;
      margin-left: 25%;
      margin-right: 25%;
    }
    .abcont2l,.abcont2c,.abcont2r{
      text-align: center;
    }

    .abcont2-1{
      display: flex;
      flex-direction: row;
      font-size: 16px;
      color: #fff;
      margin-top: 30px;
    }

    .abcont2c{
      width: 450px;
      display: flex;
      flex-direction: row;
      flex-wrap:wrap
    }
    .abcimg2,.abcimg3,.abcimg4,.abcimg5 {border-radius: 40px;}
    .abcimg2,.abcimg4,.abcont2l,.abcont2c{margin-right: 15px;}
    .abcimg2,.abcimg3{margin-bottom: 15px;}
    .abcimg1{
      width: 460px;
      height: 315px;
      background-color: #ff7269;
      border-radius: 60px;
      padding: 8px;
      img{
        border-radius: 60px;
        width: 460px;
        height: 315px;
      }
    }
    .abcimg2{
      width: 200px;
      height: 140px;
      background-color: #edc44e;
      padding: 8px;
      img{
        width: 200px;
        height: 140px;
        border-radius: 40px;
        background-position: -90px 0px;
      }
    }
    .abcimg3{
      width: 200px;
      height: 140px;
      padding: 8px;
      background-color: #6ed5a0;
      img{
        width: 200px;
        height: 140px;
        border-radius: 40px;
      }
    }
    .abcimg4{
      width: 200px;
      height: 140px;
      padding: 8px;
      background-color: #19adeb;
      img{
        width: 200px;
        height: 140px;
        border-radius: 40px;
      }
    }
    .abcimg5{
      width: 200px;
      height: 140px;
      padding: 8px;
      background-color: #dc9f5c;
      img{
        width: 200px;
        height: 140px;
        border-radius: 40px;
      }
    }
    .abcimg6{
      width: 460px;
      height: 315px;
      background-color: #5cdcda;
      border-radius: 60px;
      padding: 8px;
      img{
        border-radius: 60px;
        width: 460px;
        height: 315px;
      }
    }
  }






}

</style>
